import React from 'react';

import { SVGComponentProps } from './svg.types';

const LegalOnboardingSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path
          d="M14.6699 20.0032V22.0032H2.66992V20.0032H14.6699ZM15.2557 0.689453L23.0338 8.46763L21.6196 9.88184L20.559 9.52829L18.0841 12.0032L23.741 17.66L22.3267 19.0742L16.6699 13.4174L14.2657 15.8215L14.5486 16.9529L13.1343 18.3671L5.35621 10.589L6.77043 9.17474L7.9018 9.45758L14.195 3.16433L13.8415 2.10367L15.2557 0.689453ZM15.9628 4.22499L8.89175 11.2961L12.4272 14.8316L19.4983 7.76052L15.9628 4.22499Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default LegalOnboardingSVG;
